import { createContext } from "react";

export interface UserInfo {
  id: string;
  name: string;
  email: string;
  tenantId: string;
}

export interface AuthContextType {
  __ctx_init: boolean;
  user: UserInfo | null;
  accessToken: string | null;
  providerName: string | null;
}

export const AuthContext = createContext<AuthContextType>({
  __ctx_init: false,
  accessToken: null,
  providerName: null,
  user: null,
});
